import { Button } from 'component/Button/Button'
import { Link } from 'component/Link'
import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical/Vertical'
import { useEffectOnce } from 'hook/useEffectOnce'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { BuyPane } from 'page/tryon/BuyPane/BuyPane'
import { Footer } from 'page/tryon/Footer'
import { ImageCard } from 'page/tryon/ImageCard'
import { store } from 'page/tryon/store/TryOnPageStore'
import { useState } from 'react'
import css from './View.module.scss'

function isBoutique(url: string) {
  try {
    const u = new URL(url)
    return u.pathname.startsWith('/boutique/')
      || u.searchParams.has('boutique')
  } catch (e) {
    return false
  }
}

export const View = observer(() => {
  const { images, footer } = store.it
  const image = images[0]

  const [back] = useState(() => {
    const search = new URLSearchParams(location.search)
    const back = search.get('back') || ''
    return isBoutique(back) ? '' : back
  })

  useEffectOnce(() => {
    document.body.classList.add(css.body!)
    return () => document.body.classList.remove(css.body!)
  })

  return <Vertical className={css.page}>
    <Vertical width={400} maxWidth="calc(100% - 32px)" flex="1">
      <Vertical pad={[16, 0]} flex="1">
        <ImageCard image={image} />
      </Vertical>
      <Vertical gap={12}>
        <BuyPane />
        {back && <Link href={back}>
          <Button>
            <Icon size={16} name="west" />
            <Gap width={8} />
            {i18n('button.ToCatalog')}
          </Button>
        </Link>}
      </Vertical>
    </Vertical>
    {footer.on && <Footer />}
  </Vertical>
})
